import { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch, } from "react-icons/ai";
import { MdOutlineBarChart, MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import {  Row, Col, Container,Nav} from "react-bootstrap";
import  { generatePdf, exportToExcel, commonSelectProps } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import useAlert from "../Alert/useAlert";
import AlertModal from "../Alert/AlertModal";
import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService";import Select from 'react-select';
import { FaClipboardList, FaClock } from "react-icons/fa";import { HiOutlineClipboardDocumentList } from "react-icons/hi2";
export default function ScoregenerationReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [searchText1, setSearch1] = useState("");
 const [activeTab, setActiveTab] = useState('score_generation');const [generationResult, setGenerationResult] = useState(null);
const [YearList,setYearList] = useState([]);const [MonthList, setMonthList] = useState([]);const [Deptlist, setDeptlist] = useState([]);
 
  const formik = useFormik({
    initialValues: {
        year: "",month: "",department_id: "",type:"",scoreCatId:"",
     card_type:"",card_year:"",card_month:"",card_scoreCatId:""
    },

  })
const [getdata, setgetdata] = useState([]);
const [roleslist, setroleslist] = useState([]);


 let username = localStorage.getItem("username");
 useEffect(() => {
        
      MasterService.getfinyears().then((achievvalueres) => {
                       if (achievvalueres.data) {
                         let options = achievvalueres.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
                         setYearList(achievvalueres.data || []);
                       }
                     });
                     let param = { userId: username }
 MasterService.getkpiMonths(param).then((res) => {
      if (res.data && res.data.SCODE === "01") { 
         let options = res.data.SDESC.map((item, i) => { return ( <option key={i} value={item.month_order}> {item.month_name} </option> ); });
        setMonthList(res.data.SDESC || []); }
      else { setMonthList([]); }
    });

        MasterService.getAllDepts(param).then((res) => { if (res.data) { let options = res.data?.SDESC.map((item, i) => { return (<option key={i} value={item.dept_id}> {item.dept_name} </option>); }); 
        // setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ])
        setDeptlist([ { dept_id: "0", dept_name: "All" }, ...(res.data?.SDESC ?? []) ]); } });

}, []);
  
const filteredDataa = searchText1.length > 0 && getdata?.length ? getdata.filter((item) => { return ( item && Object.keys(item).some((key) => { const value = item[key]; return ( value !== null && value .toString() .toLowerCase() .includes(searchText1.toLowerCase()) ); }) ); }) : getdata;

 const GenerateReport = () => {
    if (!formik.values.year || !formik.values.month || 
        (formik.values.type !== "sdg" && !formik.values.department_id|| !formik.values.scoreCatId)) { showAlertMessage("Please select Year, Month, HOD Name and Score-Cat"); return; } 
    let params={};
        if(formik.values.type === "sdg"){
            params = {
            "scoreForYear": formik.values.year,
            "scoreForMonth": formik.values.month?.toString(),
            "scoreCatId":formik.values.scoreCatId,
            }
        }
        else{
        params={
        "year":formik.values.year,
"month":formik.values.month?.toString(),
"deptId":formik.values.department_id,
"scoreCatId":formik.values.scoreCatId
        }
    }
   
store.dispatch({ type: "SHOW_SPINNER" });
     let serviceCall="";
    if (formik.values.type ==="kpi") { serviceCall = KpiService.kpiScoreGeneration(params); }
     else if (formik.values.type === "economic") { serviceCall = KpiService.kpiEconomicScoreGeneration(params); } 
    else if (formik.values.type === "sdg") { serviceCall = KpiService.sdgDashboardScores(params); } 
    else if (formik.values.type === "fin_ind") { serviceCall = KpiService.kpiFINSpclScoreGeneration(params); } 
   
    
    if (serviceCall) {
        serviceCall.then((res)=>{ 
         if (res.data && res.data.SCODE === "01") { showAlertMessage(res.data.SDESC,"success"); } 
         else { showAlertMessage(res.data?.SDESC || "Error generating report","warning"); } })
         .catch((error) => { showAlertMessage("Error generating report","warning"); })
         .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
 }
}


const GenerateCardReport = () => {
    if (!formik.values.card_year || !formik.values.card_month || !formik.values.card_scoreCatId) { showAlertMessage("Please select Year, Month and Score-Cat"); return; } 
   
           let params = {
           "userId": username,
    "scoreForMonth":formik.values.card_month?.toString(),
    "scoreForYear": formik.values.card_year,
    "scoreCatId":formik.values.card_scoreCatId,
            }
      
store.dispatch({ type: "SHOW_SPINNER" });
     let serviceCall="";
    if (formik.values.card_type ==="constituency") { serviceCall = KpiService.criteriaPerformanceDashboardConstituencyScore(params); }
     else if (formik.values.card_type === "district") { serviceCall = KpiService.criteriaPerformanceDashboardScore(params); } 
    else if (formik.values.card_type === "mandal") { serviceCall = KpiService.criteriaPerformanceDashboardMandalScore(params); } 
    else if (formik.values.card_type === "hod") { serviceCall = KpiService.criteriaPerformanceDashboardHODScore(params); }
    
    if (serviceCall) {
        serviceCall.then((res)=>{ 
         if (res.data && res.data.SCODE === "01") {  setGenerationResult(res.data?.rowsInserted);showAlertMessage(res.data.SDESC,"success");  } 
         else { setGenerationResult(null);showAlertMessage(res.data?.SDESC || "Error generating report","warning"); } })
         .catch((error) => { setGenerationResult(null);showAlertMessage("Error generating report","warning"); })
         .finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
 }
}
const emptyvalues = () => {
  formik.setFieldValue("year", "");
  formik.setFieldValue("month", "");
  formik.setFieldValue("department_id", "");
  formik.setFieldValue("scoreCatId", "");
}
const emptycardvalues = () => {
  setGenerationResult(null);
  formik.setFieldValue("card_year", "");
  formik.setFieldValue("card_month", "");
  formik.setFieldValue("card_department_id", "");
  formik.setFieldValue("card_scoreCatId", "");
}
  return (
    <>
      <Menubar />
      <Container fluid  className='map-header1'  >
        <div className='sa-title'>
          <h2>Scores <span>Generation</span></h2>
        </div>
      </Container>

      <Container fluid style={{ width: "87%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
                  <Form onSubmit={formik.handleSubmit}>
                    {/* <div className="table-section-wrapper mt-2" style={{ textAlign: "center", }} >
                    
                                            <div className="Performancetabs">
                                                <Nav variant="pills" className="tabs-row d-flex flex-wrap justify-content-start gap-2 ">
                                                  
        
        <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0" style={{ maxWidth: '140px' }}>
          <Nav.Item className={`tab-boxes tab-boxes2 ${activeTab === 'score_generation' ? 'dash-active-tab' : ''}`} onClick={() => { setActiveTab("score_generation");emptyvalues();emptycardvalues(); }} style={{ cursor: 'pointer', }} > <p>Score Generation</p> </Nav.Item>
        </Col>
          <Col xxl={2} xl={2} lg={3} md={3} sm={12} xs={6} className="px-0" style={{ maxWidth: '140px' }}>
          <Nav.Item className={`tab-boxes tab-boxes1 ${activeTab === 'card_scores_generation' ? 'dash-active-tab' : ''}`} onClick={() => { setActiveTab("card_scores_generation");emptycardvalues();emptyvalues(); }} style={{ cursor: 'pointer', }}> <p>Score Card Scores Generation</p> </Nav.Item>
        </Col>
                             
                                                </Nav>
                                            </div>
                                            </div> */}
        

<div className="request-subtabs-wrapper mb-4 mt-3">

    <Nav className="request-subtabs">

      <Nav.Item className="request-subtab-item">
        <Nav.Link active={activeTab === "score_generation"} onClick={() => { setActiveTab("score_generation");emptyvalues();emptycardvalues();formik.setFieldValue("type", "");formik.setFieldValue("card_type", ""); }} className={`request-subtab-btn ${ activeTab === "score_generation" ? "request-subtab-active" : "" }`} > <span className="request-subtab-icon"> <HiOutlineClipboardDocumentList size={24} /> </span> <div className="request-subtab-content"> <span className="request-subtab-title"> Score Generation </span> <small className="request-subtab-desc">Generate Evaluation scores </small> </div> </Nav.Link>
      </Nav.Item>

      <Nav.Item className="request-subtab-item">
        <Nav.Link active={activeTab === "card_scores_generation"} onClick={() => { setActiveTab("card_scores_generation");emptycardvalues();emptyvalues();formik.setFieldValue("type", "");formik.setFieldValue("card_type", ""); }} className={`request-subtab-btn ${ activeTab === "card_scores_generation" ? "request-subtab-active" : "" }`} > <span className="request-subtab-icon"> <MdOutlineBarChart size={24} /> </span> <div className="request-subtab-content"> <span className="request-subtab-title"> Score Card Scores Generation </span> <small className="request-subtab-desc"> Generate final scorecard results </small> </div> </Nav.Link>
      </Nav.Item>
{/* Generate final scorecard results for card-based evaluations */}
    </Nav>

  </div>
             
            
{activeTab === "score_generation" &&<>
  <div className="score-form-card">

    <div className="score-form-header">
      <h5 className="mb-0">Score Generation</h5>
    </div>

    <div className="score-form-body">

      
 <Row className="g-4"><Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
 <label className="fw-bold mb-1">Type</label>
 <Field component="select" name="type" className="form-control" onChange={(e)=>{emptyvalues();formik.handleChange(e)}}><option value="">--Select--</option>
 <option value="kpi">Score Generation</option>
 <option value="economic">Economic Score Generation</option>
 <option value="sdg">SDG Score Generation</option>
 <option value="fin_ind">Financial Indicators Score Generation</option>

 </Field></Col>
</Row>
 {formik.values.type &&
  <Row className="mt-3">
    <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
 <label className="fw-bold">Year</label>
 <Select
    {...commonSelectProps({
      name: "year",
      options: YearList,
      value: formik.values.year,
      optionValueKey: "id",
      optionLabelKey: "value",
      formik,
      extraOnChange: (option) => {
       
      },
    })}
  />
 </Col>

<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
 <label className="fw-bold">Month</label>
 <Select
    {...commonSelectProps({
      name: "month",
      options: MonthList,
      value: formik.values.month,
      optionValueKey: "month_order",
      optionLabelKey: "month_name",
      formik,
      extraOnChange: (option) => {
       
      },
    })}
  />
 </Col>
 {formik.values.type !== "sdg" &&
<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
<label className="fw-bold" > HOD Name</label> 
<Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, isDisabled: false, extraOnChange: (option) => {  } })} />
</Col>
}
<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
<label className="fw-bold">Score-Cat</label>
 <Field component="select" name="scoreCatId" className="form-control" onChange={(e)=>{formik.handleChange(e)}}><option value="">--Select--</option>
 <option value="Monthly">Monthly</option>
 <option value="Annually">Annually</option>
 <option value="Provisionally">Provisionally</option>

 </Field>
</Col>
<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} style={{marginTop:"23px"}}>
<button type="button" className="btn btn-success" onClick={() => {GenerateReport() }} >Generate</button>
</Col>
 </Row>
}
</div>
</div>
</>}


{activeTab === "card_scores_generation" &&<>
<div className="score-form-card">

    <div className="score-form-header">
      <h5 className="mb-0">Score Card- Score Generation</h5>
    </div>

    <div className="score-form-body">
 <Row><Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} >
 <label className="fw-bold mb-1">Type</label>
 <Field component="select" name="card_type" className="form-control" onChange={(e)=>{emptycardvalues();formik.handleChange(e)}}><option value="">--Select--</option>
 <option value="hod">HOD/State score card scores generation</option>
 <option value="district">District score card scores generation</option>
 <option value="mandal">Mandal score card scores generation</option>
 <option value="constituency">Constituency score card scores generation</option>

 </Field></Col>
</Row>
 {formik.values.card_type &&
  <Row className="mt-3">
    <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
 <label className="fw-bold">Year</label>
 <Select
    {...commonSelectProps({
      name: "card_year",
      options: YearList,
      value: formik.values.card_year,
      optionValueKey: "id",
      optionLabelKey: "value",
      formik,
      extraOnChange: (option) => {
       
      },
    })}
  />
 </Col>

<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
 <label className="fw-bold">Month</label>
 <Select
    {...commonSelectProps({
      name: "card_month",
      options: MonthList,
      value: formik.values.card_month,
      optionValueKey: "month_order",
      optionLabelKey: "month_name",
      formik,
      extraOnChange: (option) => {
       
      },
    })}
  />
 </Col>
 
<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} >
<label className="fw-bold">Score-Cat</label>
 <Field component="select" name="card_scoreCatId" className="form-control" onChange={(e)=>{formik.handleChange(e)}}><option value="">--Select--</option>
 <option value="Monthly">Monthly</option>
 <option value="Annually">Annually</option>
 <option value="Provisionally">Provisionally</option>

 </Field>
</Col>
<Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12} style={{marginTop:"23px"}} >
<button type="button" className="btn btn-success" onClick={() => {GenerateCardReport() }} >Generate</button>
</Col>
 </Row>
}

{generationResult && (
  <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
  <div className="card mt-3 shadow-sm">
    <div className="card-header d-flex justify-content-between align-items-center">
      <h6 className="mb-0">Rows Inserted</h6>
      {/* <span className="badge bg-success">
        Total: {generationResult.totalInserted}
      </span> */}
    </div>

    <div className="card-body py-2">
      {Object.entries(generationResult)
        .filter(([key]) => key !== "totalInserted")
        .map(([key, value]) => (
          <div
            key={key}
            className="d-flex justify-content-between align-items-center py-1"
          >
            <small className="fw-medium">
              {key.replaceAll("_", " ")}
            </small>

            <span
              // className={`badge ${
              //   value > 0 ? "bg-success" : "bg-secondary"
              // }`}
            >
              {value}
            </span>
          </div>
        ))}
    </div>
  </div>
  </Col>
)}
</div></div>
</>}
           </Form></FormikProvider>

<AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
      </Container >
    </>
  );
};



